package com.qrkontaq.ui.sections.services.components

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.theme.AppColors
import com.qrkontaq.ui.theme.AppTypography
import com.qrkontaq.ui.utils.responsiveBorderRadius
import com.qrkontaq.ui.utils.responsiveFontSize
import com.qrkontaq.ui.utils.responsiveHeight
import com.qrkontaq.ui.utils.responsivePadding
import com.qrkontaq.ui.utils.responsiveWidth
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

val ServiceCardStyle = CssStyle {
    base {
        Modifier
            .transition(
                Transition.of("transform", 300.ms, AnimationTimingFunction.EaseInOut),
                Transition.of("box-shadow", 300.ms, AnimationTimingFunction.EaseInOut)
            )
    }
    hover {
        Modifier
            .translateY((-8).px)
            .styleModifier {
                property("box-shadow", "0 12px 32px rgba(0, 0, 0, 0.2)")
            }
    }
}

@Composable
internal fun ServiceCard(
    title: String,
    description: String,
    emoji: String
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Box(
        ServiceCardStyle
            .toModifier()
            .responsivePadding(32, 32)
            .responsiveBorderRadius(16)
            .backgroundColor(colors.surfaceVariant)
            .responsiveWidth(300, minMultiplier = 0.8, maxMultiplier = 1.0)
            .responsiveHeight(300, minMultiplier = 0.8, maxMultiplier = 1.2)
    ) {
        Column(
            Modifier.styleModifier { property("gap", "1rem") },
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            SpanText(
                emoji,
                Modifier.responsiveFontSize(48)
            )

            SpanText(
                title,
                Modifier
                    .responsiveFontSize(24)
                    .fontWeight(FontWeight.Bold)
                    .color(colors.textPrimary)
                    .fontFamily(AppTypography.SECONDARY_FONT_NAME, AppTypography.SECONDARY_FONT_FALLBACK)
                    .textAlign(TextAlign.Center)
            )

            SpanText(
                description,
                Modifier
                    .responsiveFontSize(15)
                    .color(colors.textSecondary)
                    .lineHeight(1.6)
                    .textAlign(TextAlign.Center)
            )
        }
    }
}
